module.exports = __webpack_public_path__ + "static/media/notegpt_ai.5911fc1d.png";